"use client"

import { UserDetails, ProductDetails} from "./includes";
import useCart from "./useCart";

const Cart = () => {
  const { data } = useCart();
  if(!data || !data.cart_lines || data.cart_lines.length === 0) return null;
  return (
    <div className="flex flex-col md:flex-row gap-x-6 xl:gap-x-10 relative">
      <UserDetails />
      <ProductDetails />
    </div>
  );
};

export default Cart;
